<template>
  <div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">过户状态：</div>
          <Select
            class="bj-select-h45 bj-bg-color-26262A "
            v-model="transferStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in transferStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-left: 10px;">
          <Input
            class="bj-input-26262A bj-input-h45"
            v-model="domainName"
            placeholder="请输入搜索的域名名称"
            style="width: 300px"
            clearable
          />
        </div>
        <div class="item" style="margin-left: 10px;">
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button class="bj-border-F85A36" @click="onSearchCancel">重置</Button>
        </div>
      </div>
    </div>  
    <div class="bj-table-data">
      <div class="total">收到的请求<span class="count">（{{ total }}）</span></div>
      <Table
        class="bj-2F3033-table"
        stripe
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="transferStatus" slot-scope="{ row }">
          <div>
            {{ row.status | status }}
          </div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          :current="page"
          :total="total"
          :page-size="limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getTemplatesTransferList } from "api/domain.js";
export default {
  name: "templatesTransferList",
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未处理";
          break;
        case 1:
          title = "处理中";
          break;
        case 2:
          title = "成功";
          break;
        case 3:
          title = "失败";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      transferStatus: "",
      transferStatusList: [
        {
          value: 0,
          label: "未处理",
        },
        {
          value: 1,
          label: "处理中",
        },
        {
          value: 2,
          label: "成功",
        },
        {
          value: 3,
          label: "失败",
        },
      ],
      domainName: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          title: "域名",
          align: "center",
          key: "ym",
        },
        {
          title: "模板名称",
          align: "center",
          key: "newTemplate",
        },
        {
          title: "原模板",
          align: "center",
          key: "oldTemplate",
        },
        {
          title: "创建时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "过户状态",
          align: "center",
          slot: "transferStatus",
        },
        {
          title: "完成时间",
          align: "center",
          key: "finalTime",
        },
      ],
      data: [],
      tableLoading: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          ym: this.domainName,
          status: this.transferStatus,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await getTemplatesTransferList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.domainName = "";
      this.transferStatus = "";
      this.onPageChange(1);
    },
  },
};
</script>
<style lang="less" scoped>
.bj-search-section{
    background-color: #28292C;
    padding: 30px 28px;
    border-radius: 6px;
    margin-top: 40px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
</style>

